// Free shipping threshold in pence. £50.00 = 5000.
// Change this single number if your free shipping threshold ever changes.
const FREE_SHIPPING_THRESHOLD = 5000;

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      try {
        const target = document.getElementById(section.id);
        const html = parsedState.sections && parsedState.sections[section.id];

        if (!target) {
          console.warn(`cart-notification: elemento #${section.id} não encontrado no DOM.`);
          return;
        }
        if (!html) {
          console.warn(`cart-notification: parsedState.sections['${section.id}'] veio vazio/ausente.`);
          return;
        }

        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } catch (error) {
        console.warn(`cart-notification: falha ao atualizar a seção '${section.id}':`, error);
      }
    });

    this.updateFreeShippingBar();

    if (this.header) this.header.reveal();
    this.open();
  }

  updateFreeShippingBar() {
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((response) => response.json())
      .then((cart) => this.renderFreeShippingBar(cart.total_price))
      .catch((error) => console.error('Free shipping bar error:', error));
  }

  renderFreeShippingBar(totalPrice) {
    const wrapper = document.getElementById('cart-notification-free-shipping');
    if (!wrapper) return;

    const messageEl = wrapper.querySelector('.cart-notification__free-shipping-message');
    const barEl = wrapper.querySelector('.cart-notification__free-shipping-bar');
    if (!messageEl || !barEl) return;

    const remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    const percentage = Math.min(100, Math.max(0, (totalPrice / FREE_SHIPPING_THRESHOLD) * 100));

    if (remaining > 0) {
      const remainingFormatted = (remaining / 100).toFixed(2);
      messageEl.innerHTML = `You're <strong>£${remainingFormatted}</strong> away from free UK shipping!`;
      wrapper.classList.remove('cart-notification__free-shipping--complete');
    } else {
      messageEl.innerHTML = `You've qualified for <strong>free UK shipping</strong>!`;
      wrapper.classList.add('cart-notification__free-shipping--complete');
    }

    barEl.style.width = `${percentage}%`;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!el) {
      throw new Error(`selector '${selector}' não encontrou nada no HTML retornado pela seção.`);
    }
    return el.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);